define('app/factories/class_toggle_factory',['app/setup'],
  function (takhfifan) {
    $('.tkh-class-toggle').click(function () {
      var $this = $(this);
      $this.toggleClass($this.data('eventClass'));
    });
  });

